export default __webpack_public_path__ + "static/media/logo.ed9fb4b8.svg";